/* global angular, moment */
/**
 * Created by lari on 07/06/2017.
 */
(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular
    .module('vcutils.map', [
      'restmod',
      'ui.router',
      'ngLodash',
      'ui.bootstrap'
    ]);
}());